export default "__VITE_ASSET__D57CIEdR__"